const pathname = window.location.pathname;
export const location = pathname.split('/').pop();

